if (!customElements.get('bm-rogues')) {
  customElements.define('bm-rogues', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;
        // Keep native fragment navigation: it also works without JavaScript and
        // scrolls the correct ancestor in the theme editor's preview.
        // The section's scroll-margin-top accounts for the sticky header.
        target.tabIndex = -1;
        target.focus({ preventScroll: true });
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
